import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import LoginPage from "./components/_login";
import PrivateRoute from "./components/_protectRouter";
import SurveyManagementPage from "./components/SurveyManagementPage";
import CreateSurveyPage from './pages/CreateSurveyPage'; 
import PublicSurveyPage from './pages/PublicSurveyPage';
import SurveyResponsesPage from './pages/SurveyResponsesPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard'; 
import SuperAdminImages from './pages/SuperAdminImages';
import SuperAdminDealers from './pages/SuperAdminDealers';
import SuperAdminSurveys from './pages/SuperAdminSurveys';
import SuperAdminResponses from './pages/SuperAdminResponses';
import SuperAdminQuotes from './pages/SuperAdminQuotes';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SuperAdminDealerDetails from './pages/SuperAdminDealerDetails';

function App() {
  return (
    <Routes>
      {/* Default route redirects to Login */}
      <Route path="/" element={<Navigate to="/login" />} />

      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/survey/public/:token" element={<PublicSurveyPage />} />

      Survey Management Routes
      <Route 
        path="/survey-management/new"
        element={
          <PrivateRoute> 
            <CreateSurveyPage />
          </PrivateRoute>
        }
      />

      <Route 
        path="/survey-management"
        element={
          <PrivateRoute> 
            <SurveyManagementPage />
          </PrivateRoute>
        }
      />

      <Route 
        path="/dashboard/survey-management/:surveyId/responses"
        element={
          <PrivateRoute> 
            <SurveyResponsesPage />
          </PrivateRoute>
        }
      />

      {/* SuperAdmin Routes */}
      <Route 
        path="/super-admin/dashboard"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminDashboard />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/images"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminImages />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/dealers"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminDealers />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/surveys"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminSurveys />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/responses"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminResponses />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/quotes"  
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminQuotes />
          </PrivateRoute>
        }
      />

      <Route 
        path="/super-admin/dealers/:dealerId"
        element={
          <PrivateRoute requiredRole="SUPERADMIN"> 
            <SuperAdminDealerDetails />
          </PrivateRoute>
        }
      />

      {/* Main Dashboard (Dealer) */}
      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute> 
            <Dashboard />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;